import { useMemo } from "react";
import ChartCanvas from "components/ChartCanvas";
import { PAYMENT_METHOD } from "data/paymentConts";
import { toCurrencyFormat } from "helpers/utils";
import paymentsService from "services/admin/paymentsService";
import { useDashboardQuery } from "../dashboard-utils";
import { getPeriodLabel } from "../periods";
import ChartCard from "./ChartCard";
import { CHART_PALETTE, pieOptions } from "./chartOptions";

const OPTIONS = pieOptions((v) => toCurrencyFormat(v, "KZT"));

const PaymentMethodStats = ({ month }) => {
  const q = useDashboardQuery(["payment-methods", month], async () => (await paymentsService.getPaymentsMethodCounts({ month })).data);

  const rows = useMemo(
    () => (Array.isArray(q.data) ? q.data.filter((r) => Number(r?.total) > 0).sort((a, b) => b.total - a.total) : []),
    [q.data]
  );
  const chartData = useMemo(
    () => ({
      labels: rows.map((r) => PAYMENT_METHOD[r.paymentMethod] || r.paymentMethod || "Не указан"),
      datasets: [
        {
          label: "Выручка",
          data: rows.map((r) => Number(r.total)),
          backgroundColor: rows.map((_, i) => CHART_PALETTE[i % CHART_PALETTE.length]),
          borderWidth: 0,
          spacing: 2,
        },
      ],
    }),
    [rows]
  );

  return (
    <ChartCard
      title="Методы оплаты"
      periodLabel={getPeriodLabel(month)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
      empty={rows.length === 0}
    >
      <ChartCanvas type="doughnut" data={chartData} options={OPTIONS} height={280} />
    </ChartCard>
  );
};

export default PaymentMethodStats;
